export default __webpack_public_path__ + "static/media/MobileVersionWebsiteFounders.a8b6703f.png";